import settingApi from '@/api/setting'

const classes={
  namespaced:true,
  state:{
    wechatSetting:{}
  },
  mutations:{
    setWechatSetting:(state,data)=>{
      state.wechatSetting=data
    }
  },
  actions:{    
    async GetWechatSetting({commit}){
      const res= await settingApi.getWechatSetting()
      commit('setWechatSetting',res.result)
    },
    async UpdateWechatSetting({commit},input){
      commit
      await settingApi.updateWechatSetting(input)
    }
  }
}
export default classes